import React, { useState,createContext, useContext } from 'react';

const FirebaseQuotaContext = createContext();

export const FirebaseQuotaProvider = ({ children }) => {

    const [firebaseQuota, setFirebaseQuota] = useState();

  return (
    <FirebaseQuotaContext.Provider value={{ firebaseQuota, setFirebaseQuota }}>
      {children}
    </FirebaseQuotaContext.Provider>
  );
};

export const useFirebaseQuotaContext = () => useContext(FirebaseQuotaContext);